import React from "react"

const styles = {
    container: {
        backgroundColor:'#ecf0f4',
        height:'100%',
        padding: '2rem',
        // overflowY: 'scroll'
    }
}
const SidebarContainer = ({ children }) => (
    <div style={styles.container}>
        {children}
    </div>
)

export default SidebarContainer